/** Scheda NC (8D leggero) e costo della non qualità. */
import type { Forma } from "../forma";

export const it = {
  sottotitolo: "{{tipo}} · da ",
  fornitoreDi: "fornitore",
  fase: "fase {{fase}}",
  chiusa: "chiusa",
  daFare: "da fare",
  fatto: "compilato",
  suggerimenti: {
    D1: "Chi lavora la NC: owner e partecipanti",
    D2: "Il problema, come lo vede il cliente",
    D3: "Cosa facciamo subito per proteggere il cliente",
    D4: "Perché è successo",
    D5: "Cosa cambiamo perché non si ripeta (obbligatoria)",
    D6: "Fatto, quando, da chi",
    D7: "Dove altro può succedere: altri fornitori, altri clienti, procedura",
    D8: "Verifica dell'efficacia dopo N consegne, poi chiusura",
  },
  faseCorrente: "Fase corrente",
  owner: "Owner",
  ownerPh: "da assegnare",
  funzione: "Funzione",
  scadenza: "Scadenza",
  fornitore: "Fornitore",
  costoStimato: "Costo stimato",
  verificaDopo: "Verifica dopo",
  esito: "Esito",
  pesoRating: "Peso sul rating",
  salva8d: "Salva l'8D",
  salvato: "NC salvata",
  chiudi: "Chiudi la NC",
  chiudiNota: "Nota di chiusura (facoltativa)",
  chiudiNonPronta: "Per chiudere servono l'azione di lungo termine (D5) e la verifica dell'efficacia con esito «Efficace».",
  chiusaOk: "NC chiusa",
  riapri: "Riapri",
  riapriMotivo: "Motivo della riapertura",
  riapertaOk: "NC riaperta",
  chiusaIl: "Chiusa il {{data}}: non si modifica, si riapre con un motivo.",
  costoTitolo: "Costo della non qualità",
  costoTotale: "Totale",
  costoSalva: "Salva i costi",
  costoSalvato: "Costi salvati",
  recuperabile: "Recuperabile dal fornitore",
  apriClaim: "Apri claim",
  claimAperto: "Claim {{codice}} aperto",
  fornitoreTitolo: "Fornitore",
  rating: "Rating",
  ratingDa: "dal VendorHub",
  ncAudit: "NC da audit",
  ncAuditDa: "da Audit Plan, in arrivo",
  altriCasi: "Altri casi",
  altriCasiValore: "{{nc}} NC · {{claim}} claim",
  allegati: "Allegati",
  allegatiInArrivo: "Foto, report 8D del fornitore, mail: in arrivo",
  scaduta: "scaduta",
};

export const en: Forma<typeof it> = {
  sottotitolo: "{{tipo}} · from ",
  fornitoreDi: "supplier",
  fase: "step {{fase}}",
  chiusa: "closed",
  daFare: "to do",
  fatto: "filled in",
  suggerimenti: {
    D1: "Who works on the NC: owner and team",
    D2: "The issue, as the customer sees it",
    D3: "What we do right away to protect the customer",
    D4: "Why it happened",
    D5: "What we change so that it does not happen again (required)",
    D6: "Done, when, by whom",
    D7: "Where else it can happen: other suppliers, other customers, procedure",
    D8: "Effectiveness check after N deliveries, then closure",
  },
  faseCorrente: "Current step",
  owner: "Owner",
  ownerPh: "to be assigned",
  funzione: "Function",
  scadenza: "Deadline",
  fornitore: "Supplier",
  costoStimato: "Estimated cost",
  verificaDopo: "Check after",
  esito: "Outcome",
  pesoRating: "Weight on rating",
  salva8d: "Save the 8D",
  salvato: "NC saved",
  chiudi: "Close the NC",
  chiudiNota: "Closing note (optional)",
  chiudiNonPronta: "To close it you need the long term action (D5) and the effectiveness check with outcome “Effective”.",
  chiusaOk: "NC closed",
  riapri: "Reopen",
  riapriMotivo: "Reason for reopening",
  riapertaOk: "NC reopened",
  chiusaIl: "Closed on {{data}}: it cannot be edited, reopen it with a reason.",
  costoTitolo: "Cost of poor quality",
  costoTotale: "Total",
  costoSalva: "Save costs",
  costoSalvato: "Costs saved",
  recuperabile: "Recoverable from the supplier",
  apriClaim: "Open claim",
  claimAperto: "Claim {{codice}} opened",
  fornitoreTitolo: "Supplier",
  rating: "Rating",
  ratingDa: "from VendorHub",
  ncAudit: "Audit NCs",
  ncAuditDa: "from Audit Plan, coming soon",
  altriCasi: "Other cases",
  altriCasiValore: "{{nc}} NCs · {{claim}} claims",
  allegati: "Attachments",
  allegatiInArrivo: "Photos, supplier 8D report, emails: coming soon",
  scaduta: "overdue",
};
